<template>
    <b-container fluid>
        <b-row>
            <div class="col-sm-4 mt-3">
                <label for="" class="form-label">Nombre</label>
                <input type="text" id="campo_nombre_unidades" class="form-control form-control-sm" v-model="nombre">
            </div>

            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Cant. por lotes</label>
                <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                    v-model="cantidad_por_lotes">
            </div>

            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Unidades</label>
                <input type="number" step="0.01" min="1" class="form-control form-control-sm" v-model="unidades">
            </div>

            <div class="col-sm-2 mt-5">
                <button v-if="permisos['inventarios.rayo.medidas']?.crear || datos_usuario.parametros.roles.includes('ROOT')" type="button"
                    class="btn btn-sm btn-block btn-outline-dark" @click="guardar">Agregar</button>
                <button v-else type="button" disabled class="btn btn-sm btn-block btn-outline-dark">Agregar</button>
            </div>

            <div class="col-sm-12 mt-3">
                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 60%;">
                                Descripción
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Cantidad por lotes
                            </th>
                            <th style="width: 5%;text-align: center;">
                                <i class="fa-solid fa-arrow-right"></i>
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Unidades
                            </th>
                            <th style="width: 10%;text-align: center;">
                                ...
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in unidades_" :key="index">
                            <td>
                                {{ item.descripcion }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.cantidad_por_lotes }}
                            </td>
                            <td style="text-align: center;">
                                <div style="height: 25px;display: flex;justify-content: center;align-items: center;">
                                    <i class="fa-solid fa-arrow-right"></i>
                                </div>
                            </td>
                            <td style="text-align: center;">
                                {{ item.unidades }}
                            </td>
                            <td style="text-align: center;">
                                <b-button v-if="permisos['inventarios.rayo.medidas']?.borrar || datos_usuario.parametros.roles.includes('ROOT')" type="button" size="sm"
                                    style="font-size: 10px;margin-right: 5px;" variant="outline-dark"
                                    @click="borrar_registro(item)"><i class="fas fa-trash"></i></b-button>
                                <b-button v-else type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark" disabled><i class="fas fa-trash"></i></b-button>
                                <b-button v-if="permisos['inventarios.rayo.medidas']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')" type="button" size="sm"
                                    style="font-size: 10px;" variant="outline-dark"
                                    @click="abrir_modal_actualizar(item)"><i class="fas fa-pen"></i></b-button>
                                <b-button v-else type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                    disabled><i class="fas fa-pen"></i></b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-row>

        <Actualizar v-if="modal_actualizar" :item="item" v-on:salir="cerrar_modal_actualizar" />

    </b-container>
</template>

<script>
    import { minix, pregunta } from '@/components/functions/alertas'
    import { mapActions, mapState } from 'vuex'

    import Actualizar from './Actualizar.vue'

    export default {
        name: 'ListaUnidades',
        computed: {
            ...mapState(['unidades_', 'permisos', 'datos_usuario'])
        },
        components: {
            Actualizar
        },
        data() {
            return {
                nombre: '',
                cantidad_por_lotes: '',
                unidades: '',
                modal_actualizar: false,
                item: {}
            }
        },
        methods: {
            async guardar() {

                if (this.nombre == '' || this.cantidad_por_lotes == '' || this.unidades == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    let f = {
                        api: `unidades`,
                        formulario: {
                            descripcion: this.nombre.toUpperCase().trim(),
                            cantidad_por_lotes: this.cantidad_por_lotes,
                            unidades: this.unidades
                        }
                    }

                    await this.guardar_data(f)
                    await this.obtener_unidades()

                    this.nombre = ''
                    this.cantidad_por_lotes = ''
                    this.unidades = ''

                    document.getElementById('campo_nombre_unidades').focus()
                }
            },
            async borrar_registro(item) {

                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Estaacción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {

                        let f = {
                            api: `unidades/${item.documentId}`,
                        }

                        await this.borrar_data(f)
                        await this.obtener_unidades()

                    }
                })

            },
            cerrar_modal_actualizar() {
                this.modal_actualizar = false
            },
            abrir_modal_actualizar(item) {
                this.item = item
                this.modal_actualizar = true
            },
            ...mapActions(['guardar_data', 'obtener_unidades', 'borrar_data'])
        },
        mounted() {
            document.getElementById('campo_nombre_unidades').focus()
        },
    }
</script>

<style></style>